import * as CONST from "./actionTypes";

const intialState = {
  vendorListData: [],
  vendorDataById: null,
  total: 0,
  loading: false,
};

const vendorReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    //get data
    case CONST.GET_VENDORS:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_VENDORS_SUCCESS:
      return {
        ...state,
        vendorListData: payload?.data,
        total: payload.totalcount,
        loading: false,
      };

    case CONST.GET_VENDORS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case CONST.UPDATE_VENDORS_LIST:
      return {
        ...state,
        vendorListData: payload,
      };

    // get vendor by id
    case CONST.GET_VENDORS_BY_ID:
      return {
        ...state,
      };

    case CONST.GET_VENDORS_BY_ID_SUCCESS:
      return {
        ...state,
        vendorDataById: payload,
      };

    case CONST.GET_VENDORS_BY_ID_FAIL:
      return {
        ...state,
      };

    // remove

    case CONST.REMOVE_VENDOR:
      return {
        ...state,
      };

    case CONST.REMOVE_VENDOR_SUCCESS:
      return {
        ...state,
      };
    case CONST.REMOVE_VENDOR_FAIL:
      return {
        ...state,
      };

    default:
      return state;

      break;
  }
};

export default vendorReducer;
